export default 
{
	"progressbar-page-title": "ページ",
	"name-suffix": "サフィックス",
	"fileupload-desc-progress-message": "アップロード {progress}",
	"required-if-greater-than-or-equal": "{compareSource}が{compareValue}以上の場合には{property}が必要です。",
	"powered-by-cognito": "Cognito Forms を搭載しました。",
	"form-name-default": "無題",
	"field-choice-defaults": "第1選択|第２選択|第３選択",
	"additional-fee-default-label": "追加料金",
	"string-length-between": "{property}は、{min}～ {max}文字で入力してください。",
	"update-button-text": "アップデート",
	"address-zip-code-invalid": "郵便番号は #####-#### としてフォーマットする必要があります。",
	"required-if-greater-than": "{compareSource}が{compareValue}超の場合には{property}が必要です。",
	"compare-before": "{property} は、{compareSource} の前にある必要があります。",
	"compare-after": "{property} は、{compareSource} 後する必要があります。",
	"unsupported-browser-message": "ああなし ！対応していないブラウザーを使用しています。{a}アップグレードする {/a} はこちら。",
	"shared-entry-email-subject": "共有リンク",
	"send-button-text": "送信",
	"venmo-help-text": "支払いを続行するには、Venmo に接続します。",
	"field-repeatingsection-item-label": "項目",
	"save-and-resume-email-not-sent-message": "問題がありました。",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} はせめて{min}である必要があります。",
	"entry-notification-full-entry-detail-link": "Cognitoforms.com で完全なエントリの詳細を表示します。",
	"element-label-website": "ウェブサイト",
	"element-label-signature": "署名",
	"paypal-help-text": "支払いを続行するには、PayPal に接続します。",
	"card-on-file-agreement-validation": "将来の取引に向かって適用されるためにクレジットカードの情報を保存することが必要です。",
	"marketing-button-4": "無料で作成できます",
	"field-datepicker-now": "現在",
	"save-and-resume-email-resume-button": "今すぐ再開",
	"field-datepicker-next-month": "翌月",
	"quantity-remaining-text": "残り",
	"payment-declined": "支払いが上承認になりました。",
	"required-if-before": "{property} {compareSource} {compareValue} の前にある場合に必要です。",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} は、{compareSource} 未満になることが必要です。",
	"entry-admin-link": "",
	"required-many": "{0} が必要です。",
	"save-and-resume-multiple-days-expiration-email-message": "{days}日以内にあなとのフォームに戻って完了するために、下のリンクをクリックしてください。",
	"string-length-at-least": "{property} は、{min} 文字以上で入力してください。",
	"credit-card-number": "クレジット カード番号",
	"range-on-or-before": "{property}は、{max}以前にする必要があります。",
	"required-one": "{0} が必要です。",
	"fileupload-max-file-count-exceeded-message": "{maxFileCount} ファイルのみをアップロードする可能性があります。",
	"order-transaction-details-header": "取引内容",
	"field-spinner-increase": "増加する",
	"payment-processing-fees": "手数料",
	"payment": "お支払い",
	"field-choice-other-fill-in": "その他",
	"shared-entry-email-message": "エントリーはあなたと共有されています。",
	"shared-entry-workflow-link": "フォームを表示します。",
	"required-if-exists": "{compareSource}が指定されている場合には{property}が必要です。",
	"concurrent-conflict-toast-message": "フォーム情報が変更されたため、送信に失敗しました。確認してからもう一度お試しください。",
	"secured-by-paypal": "ーによってセキュリティで保護されています",
	"range-on-or-after": "{property}は、{min}以降にする必要があります。",
	"payment-amount-due": "支払金額",
	"required-name-first-and-last": "氏名をご入力ください。",
	"required": "{property} が必要です。",
	"string-format-alphabetic": "{property} は、文字のみを含む必要があります。",
	"quantity-limit": "{property} 数量を超過しました。",
	"field-spinner-decrease": "下げる",
	"field-repeatingsection-add-link-text": "追加",
	"fileupload-max-size-exceeded-message": "{maxSize} MB より小さいファイルだけをアップロードする可能性があります。",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "保存されていません",
	"field-ratingscale-satisfied-unsatisfied-label": "満足・不満足",
	"range-between": "{property}は、{min}と {max}の間にある必要です。",
	"field-ratingscale-agree-disagree-label": "賛成/反対",
	"back-button-text": "戻る",
	"address-country": "国",
	"order-not-found": "注文情報が見つかりません。",
	"field-ratingscale-satisfied-unsatisfied-options": "不満/　やや不満　/　どちらともいえない　/　やや満足　/　満足",
	"entry-notification-entry-details-header": "エントリーの詳細",
	"FALSE": "偽",
	"compare-greater-than-or-equal": "{property} は {compareSource} 以上になることが必要です。",
	"receipt-notification-order-details-desc-header": "説明",
	"order-method-label": "お払い方法の指定",
	"order-total-label": "注文合計",
	"invalid-shared-link": "無効な共有リンク",
	"fileupload-zero-byte-file-message": "0 バイトのファイルをアップロードすることがあります。",
	"range-at-most": "{property} は せめて{max} である必要があります。",
	"format-integer": "####",
	"order-date-label": "日付",
	"fileupload-dropzone-message": "または、ここにファイルをドラッグします。",
	"shared-entry-view-link": "共有されたエントリを表示します。",
	"format-currency": "¥10,000",
	"string-length-at-most": "{property} は、 {max} 文字以下で入力してください。",
	"entry-confirmation-footer-tagline": "強力なお支払いのフォームを作成します。",
	"submit-button-text": "送信",
	"marketing-msg": "フォームが簡単に作成できます。",
	"required-if-on-or-after": "{compareSource} が {compareValue} 以降の場合には{property}が必要です。",
	"card-on-file-agreement": "将来の取引に向かって適用されるためにクレジットカードの情報を保存することを同意します。",
	"signature-draw": "描画する",
	"address-zip-code": "郵便番号",
	"compare-on-or-after": "{property}は、{compareSource}以降にする必要があります。",
	"required-if-less-than-or-equal": "{compareSource}が{compareValue}以下の場合には{property}が必要です。",
	"field-datepicker-next-year": "翌年",
	"change-button": "変わる",
	"fileupload-desc-size-in-bytes-message": "{size} バイト",
	"card-tab": "カード",
	"order-billing-info-header": "請求先情報",
	"entry-email-view-details-text": "CognitoForms.com で完成されたエントリを表示します。",
	"save-and-resume-one-day-expiration-email-message": "一日以内にあなとのフォームに戻って完了するために、下のリンクをクリックしてください。",
	"credit-card-authentication-failed": "カードが認証に失敗しました。",
	"compare-less-than-or-equal": "{property} は、{compareSource}以下になることが必要です。",
	"receipt-notification-order-details-balance-due": "合計金額",
	"save-and-resume-multiple-days-expiration-message": "下のリンクをコピーまたはメール送信して{days}日以内にフォームを完了して提出してください。",
	"processing-fee-calculating-message": "計算中",
	"receipt-notification-trx-details-method": "お払い方法の指定",
	"field-choice-no-match": "データなし",
	"fileupload-invalid-file-type-message": "{allowedTypes} ファイルのみをアップロードする可能性があります。",
	"receipt-notification-trx-details-date": "日付",
	"credit-card-authorization": "カード認証",
	"address-line1": "住所１",
	"required-if-not-exists": "{compareSource}が指定されていない場合には{property}が必要です。",
	"required-if-not-equal": "{compareSource}が{compareValue}ではない場合には{property}が必要です。",
	"marketing-button-2": "無料で作成できます",
	"receipt-notification-billing-info-header": "ご注文内容",
	"required-if-after": "{compareSource} は {compareValue} {property} が必要です。",
	"element-label-name": "名前",
	"required-if-equal": "{compareSource} は、{compareValue} {property} が必要です。",
	"connected-to-paypal": "PayPal に接続されました。",
	"people-form-email-quantity-exceeded-message": "メールアドレスは一意である必要があります。",
	"receipt-notification-order-details-subtotal": "小計",
	"shared-entry-edit-link": "共有されたエントリを編集します。",
	"receipt-notification-trx-details-header": "取引内容",
	"address-city": "市区都",
	"receipt-notification-order-details-amount-paid": "未払い",
	"credit-card-invalid": "カードが無効です。",
	"format-decimal": "####.##",
	"entry-notification-new-submission-text": "新しいフォームの送信があります。",
	"this-and-that": "{0} と {1}",
	"field-ratingscale-good-poor-label": "良い/悪い",
	"network-unavailable-message": "ネットワークを利用できません。しばらくしてからもう一度お試しください。",
	"dialog-close": "閉じる",
	"string-format-alphanumeric": "{property} は、文字と数字を含む必要があります。",
	"credit-card": "クレジット カード",
	"remove-item": "削除します {item}",
	"receipt-notification-order-details-price-header": "単価",
	"fileupload-upload-inprogress-message": "進行中のファイルのアップロード。",
	"public-terms-of-service-link-text": "サービス利用規約",
	"save-and-resume-email-subject": "保存と再開のリンク",
	"field-repeatingsection-remove-link-text": "削除",
	"field-ratingscale-na-label": "N/A",
	"add-item": "追加 {item}",
	"field-toggle-options": "はい/いいえ|真/偽| オープン/クローズ|始動/停止|既読/未読",
	"order-submit-timeout": "注文処理は時間が掛かります。ご注文をやり直してください。",
	"listlength-at-most": "{property}の{max} 以下で指定して下さい。",
	"shared-entry-email-view-message": "共有されたエントリを表示するために、下のリンクを使用します。",
	"order-number-label": "数",
	"card-declined": "クレジットカード決済に失敗しました。",
	"fileupload-default-upload-button-text": "アップロード",
	"name-prefix": "タイトル",
	"address-line2": "住所２",
	"element-label-email": "メールアドレス",
	"field-ratingscale-good-poor-options": "非常に悪い|悪い|平均|良い|非常にいい",
	"next-button-text": "次",
	"question": "質問",
	"address-postalcode": "郵便番号",
	"format-with-description": "{property} は、{description} としてフォーマットする必要があります。",
	"field-datepicker-prev-month": "前月",
	"name": "お名前",
	"receipt-notification-order-details-total-footer": "合計",
	"confirmation-message": "あなたの回答は送信されました。ありがとうござました。",
	"shared-entry-email-edit-message": "共有されたエントリを編集するために、下のリンクを使用します。",
	"field-default-label": "無題",
	"required-value": "{property}は{value}でなければなりません。",
	"name-middle": "ミドルネーム",
	"fileupload-failed-upload-message": "{fileName} アップロードに失敗しました。",
	"shared-entry-email-button-label": "エントリを表示します",
	"field-datepicker-year": "年",
	"element-label-phone": "携帯電話",
	"TRUE": "真",
	"listlength-between": "{property}の{min}と{max}を指定してください。",
	"marketing-button-1": "今、試してみる",
	"entry-submission-error-heading": "エントリ処理のエラー",
	"order-not-found-message": "注文情報が見つかりません。",
	"format-without-description": "{property} の形式が正しくありません。",
	"name-last": "姓",
	"field-ratingscale-one-five-label": "1-5 のスケール",
	"listlength-at-least": "{property}の{min}以上を指定してください。",
	"united-states": "米国",
	"field-signature-captured": "保存されました",
	"compare-on-or-before": "{property}は、{compareSource}以前にする必要があります。",
	"order-balance-due-label": "合計金額",
	"required-if-less-than": "{compareSource}が{compareValue}未満の場合には{property}が必要です。",
	"credit-card-postalcode": "郵便番号",
	"form-not-available-message": "現在は、このフォームをご利用いただくことはできません",
	"element-label-address": "住所",
	"receipt-notification-trx-details-number": "数",
	"public-submission-warning": "Cognito Forms でパスワードを送信しないでください。",
	"save-and-resume-no-expiration-email-message": "あなとのフォームに戻って完了するために、下のリンクをクリックしてください。",
	"fileupload-excluded-file-type-message": "この種類のファイルがアップロードされない場合があります。",
	"payment-subtotal": "小計",
	"collapse": "折りたたむ",
	"save-button-text": "保存",
	"field-datepicker-prev-year": "前年",
	"signature-type": "入力する",
	"order-amount-minimum": "合計金額は１００円以上です。",
	"string-format-numeric": "{property}は、 数字のみを含む必要があります。",
	"entry-confirmation-entry-details-header": "エントリーの詳細",
	"connected-to-venmo": "Venmo に接続しました。",
	"format-percentage": "#.##%",
	"receipt-notification-header": "領収書",
	"clear": "クリア",
	"today": "今日",
	"required-name-last": "姓をご入力ください。",
	"marketing-button-3": "無料で試してみてください",
	"expand": "展開する",
	"compare-greater-than": "{property} は、{compareSource} 超になることが必要です。",
	"field-ratingscale-will-wont-label": "する/　しない",
	"required-name-first": "名をご入力ください。",
	"save-and-resume-one-day-expiration-message": "下のリンクをコピーまたはメール送信して一日中にフォームを完了して提出してください。",
	"required-asterisk": "必須",
	"credit-card-required": "クレジット カードが必要です。",
	"address-state-province-region": "都道府県",
	"save-and-resume-email-sent-message": "電子メールが送信されました。",
	"workflow-action": "アクション",
	"field-ratingscale-will-wont-options": "絶対にしない/　多分しない/　どちらともいえない/　多分する/　絶対にしない",
	"save-and-resume-email-label": "私に私のリンクを電子メールで送信：",
	"field-ratingscale-agree-disagree-options": "全くそうは思わない/　そうは思わない/　どちらとも言えない/　そう思う/　非常にそう思う",
	"order-exception-order-already-paid": "すでにお支払い済みでした。",
	"fileupload-download-text": "ダウンロード",
	"address-state": "都道府県",
	"allowed-values": "{property} が許容値のリストにないです。",
	"shared-entry-workflow-email-button-label": "フォームを開く",
	"compare-equal": "{property} は {compareSource} と同一であることが必要です。",
	"field-datepicker-clear": "クリア",
	"name-first": "名",
	"save-and-resume-message": "あなたの進行状況が保存されました。",
	"save-and-resume-no-expiration-message": "後でフォームの提出を完了することができます。そうするために下のリンクをコピーまたはメール送信してください。",
	"entry-notification-view-details-text": "詳細を表示します。",
	"order-exception-default-message": "注文処理に失敗しました。申し訳ございません。",
	"public-report-abuse-link-text": "問題を報告",
	"order-amount-paid": "お払い合計",
	"element-label-default": "無題",
	"countries": "香港|Vincent およびグレナディン諸島|アイスランド|アイルランド|アゼルバイジャン|アフガニスタン|アメリカ領サモア|アラブ首長国連邦|アルジェリア|アルゼンチン|アルバ|アルバニア|アルメニア|アンギラ|アンゴラ|アンティグア ・ バーブーダ|アンドラ|イエメン|イスラエル|イタリア|イラク|イラン|インド|インドネシア|ウォリス ・ フツナ諸島|ウガンダ|ウクライナ|ウズベキスタン|ウルグアイ|エクアドル|エジプト|エストニア|エチオピア|エリトリア|エルサルバドル|オーストラリア|オーストリア|オマーン|オランダ|オランダ領アンティル諸島|ガーナ|カーボベルデ|ガイアナ|カザフスタン|カタール|カナダ|ガボン|カメルーン|ガンビア|カンボジア|ギニア|ギニア-ビサウ|キプロス|キューバ|ギリシャ|キリバス|キルギス|グアテマラ|グアドループ (仏領)|グアム|クウェート|クック諸島|グリーンランド|クリスマス島|グルジア|グレート ・ ブリテン|グレナダ|クロアチア|ケイマン諸島|ケニア|コートジボワール|ココス (キーリング) 諸島|コスタリカ|コソボ|コモロ|コロンビア| コンゴ共和国|コンゴ民主共和国|サウジアラビア|サモア|サントメ ・ プリンシペ|ザンビア|サンマリノ|シエラレオネ|ジブチ|ジブラルタル|ジャマイカ|シリア|シンガポール|ジンバブエ|スイス|スウェーデン|スーダン|スペイン|スリナム|スリランカ|スロバキア (スロバキア共和国)|スロベニア|スワジランド|セイシェル|セネガル|セルビア|セントクリストファー ・ ネイビス|セントルシア|ソマリア|ソロモン諸島|タークス ・ カイコス諸島|タイ|タジキスタン|チェコ共和国|タンザニア❘チベット|チャド|チュニジア|チリ|ツバル|ティモール （東ティモール）|デンマーク|ドイツ|トーゴ|トケラウ諸島|ドミニカ共和国|ドミニカ国|トリニダード・トバゴ|トルクメニスタン|トルコ|トンガ|ナイジェリア|ナウル|ナミビア|ニウエ|ニカラグア|ニジェール|ニューカレドニア|ニュージーランド|ネパール|ノルウェー|バージン諸島 （英国）|バージン諸島 （米国）|バーレーン|ハイチ|パキスタン|バチカン市国 (聖座)|パナマ|バヌアツ|バハマ|パプア ニューギニア|バミューダ諸島|パラオ|パラグアイ|バルバドス|パレスチナ自治区|ハンガリー|バングラデシュ|ピトケアン島|ビルマ ミャンマー|フィジー|フィリピン|フィンランド|ブータン|プエルトリ　コ|フェロー諸島|フォークランド諸島|ブラジル|フランス|フランス領ギアナ|フランス領ポリネシア|ブルガリア|ブルキナファソ|ブルネイ・ダルサラーム国|ブルンジ|ベトナム|ベナン|ベネズエラ|ベラルーシ|ベリーズ|ペルー|ベルギー|ポーランド|ボスニア・ヘルツェゴビナ|ボツワナ|ボリビア|ポルトガル|ホンジュラス|マーシャル諸島|マン島|マイヨット島|マカオ|マケドニア共和国|マダガスカル|マラウイ|マリ|マルタ|マルティニーク島|マレーシア|ミクロネシア連邦|メキシコ|モーリシャス|モーリタニア|モザンビーク|モナコ|モルディブ|モルドバ共和国|モロッコ|モンゴル国|モンテネグロ|モントセラト|ヨルダン|ラオス人民民主共和国|ラトビア|リトアニア|リビア|リヒテンシュタイン|リベリア|ルーマニア|ルクセンブルク|ルワンダ|レソト|レバノン|レユニオン島|ロシア連邦|英国|韓国|北朝鮮|教皇庁|西サハラ|赤道ギニア|台湾 (中華民国)|中央アフリカ共和国|中国|東ティモール （東ティモール）|南アフリカ|南スーダン|南極大陸|日本|仏領極南諸島|米国|北マリアナ諸島 ",
	"name-middleinitial": "ミドルネーム",
	"order-exception-empty-order": "順序は少なくとも 1 項目を含む必要があります。",
	"compare-not-equal": "{property} は、{compareSource} と違う必要があります。。",
	"entry-notification-footer": "Cognito Forms をフォーム上の受信電子メール通知オプションを選択したので、このメールを受け取っています。",
	"save-and-resume-copy-link-label": "フォームのリンクをコピーしてください：",
	"entry-confirmation-footer": "トランザクションを完了するためにこのメールを受け取っています。[Name].",
	"required-if-on-or-before": "{compareSource} が {compareValue} 以前の場合には{property}が必要です。",
	"string-format": "{property} は、{formatDescription} としてフォーマットする必要があります。"
};
